import { useCallback, useReducer, useState } from 'react';
import type { SelectProps } from '@mui/material';
import type {
    SelectOption,
    SelectOptions,
} from './FilterSelectWithCheckboxes.tsx';

type AddValuesSelectedValuesAction = {
    type: 'ADD_VALUES';
    payload: string[];
};
type SelectAllValuesSelectedValuesAction = {
    type: 'SELECT_ALL_VALUES';
    payload: SelectOptions;
};
type ClearSelectedValuesAction = {
    type: 'CLEAR_VALUES';
    payload: SelectOptions;
};
type DeleteSelectedValueAction = {
    type: 'DELETE_VALUE';
    payload: string;
};
type SelectedValuesAction =
    | AddValuesSelectedValuesAction
    | SelectAllValuesSelectedValuesAction
    | ClearSelectedValuesAction
    | DeleteSelectedValueAction;

function selectedValuesReducer(state: string[], action: SelectedValuesAction) {
    switch (action.type) {
        case 'ADD_VALUES': {
            // $FlowFixMe
            return action.payload;
        }
        case 'SELECT_ALL_VALUES': {
            const newOptions = action.payload.map<string>(
                (option) => option.value,
            );
            // $FlowFixMe
            return state.concat(newOptions);
        }
        case 'DELETE_VALUE': {
            // $FlowFixMe
            return state.filter((value) => value !== action.payload);
        }
        case 'CLEAR_VALUES': {
            // $FlowFixMe
            return state.filter(
                (value) =>
                    !action.payload.find((option) => option.value === value),
            );
        }
        default: {
            return state;
        }
    }
}

// It returns props for the select based on the provided arguments.
export function useFilterSelectWithCheckboxesProps(
    name: string,
    initialState: string[] | (() => string[]), // We use the items for the options
    options: SelectOptions,
) {
    // Only execute this in initial render.
    const [initial] = useState(initialState);
    const [values, dispatch] = useReducer(selectedValuesReducer, initial);

    const handleChangeSelect = useCallback<SelectProps<string[]>['onChange']>(
        function handleChangeSelect(event) {
            const addedValues = (event.target.value as string[]).filter(
                (value) => value !== null && value !== 'undefined',
            );
            dispatch({ type: 'ADD_VALUES', payload: addedValues });
        },
        [],
    );

    const handleDeleteValue = useCallback(function handleDeleteValue(
        option: SelectOption,
    ) {
        dispatch({ type: 'DELETE_VALUE', payload: option.value });
    }, []);

    const chooseAllValues = useCallback(function chooseAllValues(
        options: SelectOptions,
    ) {
        dispatch({ type: 'SELECT_ALL_VALUES', payload: options });
    }, []);

    const clearValues = useCallback(function clearValues(
        options: SelectOptions,
    ) {
        dispatch({ type: 'CLEAR_VALUES', payload: options });
    }, []);

    return {
        label: name,
        values,
        options,
        onChange: handleChangeSelect,
        onDeleteValue: handleDeleteValue,
        chooseAllValues,
        clearValues,
    };
}
